import React from 'react'

import Radio from '../../../../../../components/Form/Radio'

import { exportAsCsvLevels, LEVEL } from '../../fields'

import useDrawerFormStyles from '../../../../../../styles/common/drawerForms'
import useStyles from './styles'

const LevelSection = ({ formik, level }) => {
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormStyles()

  const { values, setFieldValue } = formik

  return (
    <section className={drawerFormClasses.section}>
      <h3 className={classes.sectionTitle}>{'Levels (Optional)'}</h3>
      <p>{'Select the level you would like to export'}</p>

      {level === exportAsCsvLevels.campaign && (
        <Radio
          titleClassName={classes.radio}
          id={'campaign_radio_button'}
          name={LEVEL}
          value={'campaign'}
          label="Campaign"
          onChange={e => {
            console.log('e', e)
            setFieldValue(LEVEL, 'campaign')
          }}
          checked={values[LEVEL] === 'campaign'}
        />
      )}

      <Radio
        titleClassName={classes.radio}
        id={'ad_set_radio_button'}
        name={LEVEL}
        value={'ad_set'}
        label="Ad Set"
        onChange={() => {
          setFieldValue(LEVEL, 'line_item')
        }}
        checked={values[LEVEL] === 'line_item'}
      />

      <Radio
        titleClassName={classes.radio}
        id={'ad_radio_button'}
        name={LEVEL}
        value={'ad'}
        label="Ad"
        onChange={() => {
          setFieldValue(LEVEL, 'ad')
        }}
        checked={values[LEVEL] === 'ad'}
      />
    </section>
  )
}

export default LevelSection
